import { render, staticRenderFns } from "./RegisterPropertyYN.vue?vue&type=template&id=a0ccde9e"
import script from "./RegisterPropertyYN.vue?vue&type=script&lang=js"
export * from "./RegisterPropertyYN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports